module.exports = __webpack_public_path__ + "ecef4b32801a687c0b82300d102f49fc.png";